import React, { ReactElement } from "react";

const TagCodeBlock = (props: any): ReactElement => (
  <span className="tag is-dark">{props.children}</span>
);

export default TagCodeBlock;
